/**
 * MFA Setup Styles - design tokens aligned with App.jsx theme
 */

export const mfaColors = {
  primary: '#2aafbb',
  secondary: '#EB8382',
  text: '#303F56',
  textMuted: '#6b7c93',
  border: '#e2e8f0',
  background: '#f8fafb',
  surface: '#ffffff',
  error: '#dc2626',
  errorLight: '#fef2f2',
  errorBorder: '#fecaca',
  success: '#10b981',
  successLight: '#d1fae5',
};

export const mfaCardStyles = {
  background: mfaColors.surface,
  borderRadius: 2,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
  border: `1px solid ${mfaColors.border}`,
};

export const mfaInputStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.5,
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: mfaColors.primary,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: mfaColors.primary,
      borderWidth: 2,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: mfaColors.primary,
  },
};

export const mfaPrimaryButtonStyles = {
  backgroundColor: mfaColors.primary,
  color: '#fff',
  fontWeight: 600,
  px: 3,
  py: 1.5,
  borderRadius: 1.5,
  textTransform: 'none',
  fontSize: '0.9375rem',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#239aa5',
    boxShadow: 'none',
  },
  '&:disabled': {
    backgroundColor: mfaColors.border,
    color: mfaColors.textMuted,
  },
};

export const mfaSecondaryButtonStyles = {
  backgroundColor: 'transparent',
  color: mfaColors.text,
  fontWeight: 500,
  px: 3,
  py: 1.5,
  borderRadius: 1.5,
  textTransform: 'none',
  fontSize: '0.9375rem',
  border: `1px solid ${mfaColors.border}`,
  '&:hover': {
    backgroundColor: mfaColors.background,
    borderColor: mfaColors.textMuted,
  },
};

export const mfaErrorStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  p: 1.5,
  borderRadius: 1,
  backgroundColor: mfaColors.errorLight,
  border: `1px solid ${mfaColors.errorBorder}`,
};

export const mfaQRContainerStyles = {
  p: 3,
  borderRadius: 2,
  backgroundColor: mfaColors.surface,
  border: `1px solid ${mfaColors.border}`,
  display: 'inline-flex',
};

export const mfaOTPContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  p: 2,
  borderRadius: 1.5,
  backgroundColor: mfaColors.background,
  border: `1px solid ${mfaColors.border}`,
};
